import { useMemo } from 'react';
import type { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import { StatusImpactPill } from '~/app/components/dashboard/StatusImpactPill/StatusImpactPill';
import type { PortfolioPropertyRowViewModel } from '../PortfolioPage.types';

export function usePortfolioPropertiesColumns(): ColumnsType<PortfolioPropertyRowViewModel> {
  const { t } = useTranslation('dashboard');

  return useMemo(
    () => [
      {
        title: t('portfolioPage.columns.location'),
        dataIndex: 'location',
        key: 'location',
        render: (value: string) => (
          <span className="om-portfolio-location">{value}</span>
        ),
      },
      {
        title: t('portfolioPage.columns.chargers'),
        dataIndex: 'chargerCount',
        key: 'chargers',
      },
      {
        title: t('portfolioPage.columns.ownership'),
        dataIndex: 'ownershipLabel',
        key: 'ownership',
      },
      {
        title: t('portfolioPage.columns.contractStatus'),
        dataIndex: 'contractStatusLabel',
        key: 'contractStatus',
      },
      {
        title: t('portfolioPage.columns.businessImpact'),
        key: 'businessImpact',
        render: (_: unknown, row: PortfolioPropertyRowViewModel) => (
          <StatusImpactPill
            tone={row.businessImpactTone}
            label={row.businessImpactLabel}
          />
        ),
      },
    ],
    [t],
  );
}
